/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {EntityListDynamicCellDirective as ɵa} from './entity-list-dynamic-cell.directive';